import { httpClient } from '@/domains/core/httpClient/httpClient';
import { HttpHeaders } from '@/domains/core/httpClient/httpHeaders';
import { getAppSetting } from '@/domains/core/settings/appSettings';
import { getPlatform } from '@/domains/core/settings/utils';

import type { TrackedProductDetails } from '../../common/interfaces/TrackedProductDetails';
import { ItemTypes, type AddToCartResponseV2 } from './interfaces/common';

export const GET_MSF_ADD_TO_CART_V2 = `/web/api/v2/cart-module/add/items`;

export const addToCartV2 = async (products: TrackedProductDetails[]) => {
  const payload = products.map((product) => ({
    quantity: product.quantity,
    type: ItemTypes.PRODUCT,
    identifier: String(product.id),
  }));

  const response = await httpClient.post<{ content: AddToCartResponseV2 }>(
    `${getAppSetting('MS_API_URL')}${GET_MSF_ADD_TO_CART_V2}`,
    payload,
    {
      headers: {
        [HttpHeaders.X_MM_PLATFORM]: getPlatform().toUpperCase(),
      },
    },
  );

  return response.data?.content;
};
